import { getLineItemLanguages } from './helpers'

import { LANGUAGES } from '../../../../../ReusableFormFields/LanguagesFields/fields'

export const getInitialValues = targeting => {
  return {
    [LANGUAGES]: getLineItemLanguages(targeting)
  }
}
